function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const createSvgIcon = ({
  width = 24,
  height = 24,
  title,
  content,
  viewBox = '0 0 25 25'
}) => props => /*#__PURE__*/React.createElement("svg", _extends({
  height: height,
  width: width,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: viewBox,
  "aria-label": title
}, props), content);

export default createSvgIcon;